// import node module libraries
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

// Define types for the state
interface Column {
  column_name: string;
}

interface Table {
  table_name: string;
  columns: Column[];
}

export interface Database {
  database_name: string;
  database_id: string;
  tables: Table[];
}

interface DatabaseState {
  databases: Database[];
  selectedDatabase: {
    database_name: string;
    database_id: string | number;
    selectedTable: string[];
  };
  allDatabases: any[];
  // selectedDBID: string;
  isDatabaseLoading: boolean;
  isQueryBankLoading: boolean;
  isQueryBankGenerated: boolean;
  addNewDb: boolean;
}

// Initial state
const initialState: DatabaseState = {
  databases: [],
  selectedDatabase: {
    database_name: "",
    database_id: "",
    selectedTable: [],
  },
  allDatabases: [],
  isDatabaseLoading: false,
  isQueryBankLoading: false,
  isQueryBankGenerated: false,
  addNewDb: false,
};

// Create the slice
const databaseSlice = createSlice({
  name: "database",
  initialState,
  reducers: {
    addDatabases: (state, action: PayloadAction<Database[]>) => {
      action.payload.forEach((newDb) => {
        const existingDatabase = state.databases.find(
          (db) => db.database_name === newDb.database_name
        );

        if (!existingDatabase) {
          state.databases.push(newDb);
          // toast.success(`Database ${newDb.database_name} added successfully.`, {
          //   position: "bottom-right",
          // });
        } else {
          toast.error(`Database ${newDb.database_name} is already exists.`);
        }
      });
    },
    selectTables: (state, action: PayloadAction<string[]>) => {
      state.selectedDatabase.selectedTable = action.payload;
    },

    selectDatabase: (
      state,
      action: PayloadAction<{
        database_name: string;
        database_id: string | number;
      }>
    ) => {
      state.selectedDatabase.database_name = action.payload.database_name;
      state.selectedDatabase.database_id = action.payload.database_id;
      state.selectedDatabase.selectedTable = [];
    },

    setNewDatabaseAdded: (
      state,
      action: PayloadAction<{
        database_name: string;
        database_id: string;
        tables: string[];
      }>
    ) => {
      state.selectedDatabase.database_name = action.payload.database_name;
      state.selectedDatabase.database_id = action.payload.database_id;
      state.selectedDatabase.selectedTable = action.payload.tables;
    },

    setQueryBankGenerated: (state, action: PayloadAction<boolean>) => {
      state.isQueryBankGenerated = action.payload;
    },

    setDatabaseLoading: (state, action: PayloadAction<boolean>) => {
      state.isDatabaseLoading = action.payload;
    },
    setQueryBankLoading: (state, action: PayloadAction<boolean>) => {
      state.isQueryBankLoading = action.payload;
    },
    addNewDatabase: (state, action: PayloadAction<boolean>) => {
      state.addNewDb = action.payload;
    },
    setAllDatabases: (state, action: PayloadAction<Database[]>) => {
      state.allDatabases = action.payload;
    },
  },
});

export const {
  addDatabases,
  selectTables,
  selectDatabase,
  setDatabaseLoading,
  setQueryBankLoading,
  setNewDatabaseAdded,
  addNewDatabase,
  setQueryBankGenerated,
  setAllDatabases,
} = databaseSlice.actions;

export default databaseSlice.reducer;
